<template>
  <div class="bd">
    <div class="container">
      <div class="title">下载</div>
      <div>
        <div>
          <el-input
            clearable
            v-model="name"
            placeholder="根据产品名称搜索"
            class="search"
            @keydown.enter.native="onSubmitQuery"
          ></el-input>
        </div>
      </div>
      <el-table
        size="medium"
        :data="itemList"
        v-loading="loading"
        :show-header="false"
        empty-text="暂无下载"
        style="font-size:16px;"
      >
        <el-table-column label="产品名称">
          <template slot-scope="{ row }">
            <div>
              <span class="show" @click="toSoftware(row.ID)">{{row.Name }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="LatestVersion.Version" label="最新版本"></el-table-column>
        <el-table-column label="发布日期">
          <template slot-scope="{ row }">
            <div>{{ $sys.dateFormat(row.LatestVersion.PublishDay, 'Y-m-d') }}</div>
          </template>
        </el-table-column>
        <el-table-column type="expand">
          <template slot-scope="{ row }">
            <el-table
              size="medium"
              v-loading="loading"
              :data="row.Versions"
              :show-header="false"
              empty-text="暂无下载"
              style="font-size:16px;"
            >
              <el-table-column label="版本号">
                <template slot-scope="{ row }">
                  <div>
                    <span class="show" @click="toVersion(row.ID)">{{row.Version }}</span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="包含功能版本">
                <template slot-scope="{ row }">
                  <el-tag
                    v-for="basics in row.Basics"
                    :key="basics.ID"
                    type="success"
                    style="margin-right:5px;font-size:14px;"
                  >{{basics.Name}}</el-tag>
                </template>
              </el-table-column>
              <el-table-column label="发布日期">
                <template slot-scope="{ row }">{{ $sys.dateFormat(row.PublishDay, 'Y-m-d') }}</template>
              </el-table-column>
            </el-table>
          </template>
        </el-table-column>
      </el-table>

      <div>
        <el-pagination
          background
          @current-change="onChangePage"
          layout="prev, pager, next"
          :total="pager.total"
          :current-page="pager.page"
          :page-size="pager.size"
          hide-on-single-page
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  data() {
    return {
      name: '',
      itemList: [],
      pager: {
        total: 0,
        page: 1,
        size: 15,
      },
      loading: false,
    };
  },
  created() {
    this.getItemList();
  },
  methods: {
    getItemList() {
      this.$axios
        .get('software/visual', {
          params: {
            where: { 'Name:like': this.name },
            with: ['Versions', 'Versions.Basics', 'Classification', 'BusinessType'],
            ...this.pager,
          },
        })
        .then((response) => {
          this.itemList = response.data.data;
          this.itemList.forEach((item) => {
            item.Versions.reverse();
          });
          this.pager = _.pick(response.data, 'size', 'page', 'total');
        })
        .catch(({ response }) => {
          this.$sys.alarmResponse(response);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // 查询
    onSubmitQuery() {
      this.pager.page = 1;
      this.getItemList();
    },
    // 翻页
    onChangePage(page) {
      this.pager.page = page;
      this.getItemList();
    },
    toSoftware(id) {
      this.$router.push({ name: 'SoftwareDetail', params: { ID: id } });
    },
    toVersion(id) {
      this.$router.push({ name: 'VersionDetail', params: { ID: id } });
    },
  },
};
</script>

<style scoped lang="scss">
.bd {
  min-height: 100vh;
  background-color: #fff;
}
.container {
  width: 1200px;
  margin: 0 auto;
  ::v-deep .el-table__row {
    height: 55px;
  }
}
.title {
  font-size: 24px;
  font-weight: 600;
  padding: 30px 10px 10px 10px;
  color: #303133;
}
.search {
  width: 200px;
  margin: 20px;
  float: right;
}
.show {
  cursor: pointer;
  color: #409eff;
}
.show:hover {
  text-decoration: underline;
}
</style>
